<template>
    <div class="layout__padding-clear layout__width-90 text__align-center">
        <h3 class="text__colour-teal layout__padding-20-0">Branch Search</h3>

        <p class="text__align-left">Search by Branch code, Agent Name or Brand<span class="text__colour-red">*</span>
        </p>
        <el-form :model="search" ref="search" :rules="rules"
                 class="layout__width-100 layout__padding-20-0">
            <el-form-item prop="freetextSearch" class="layout__padding-20-0">
            <el-input v-model="search.freetextSearch" class="layout__width-100" clearable autofocus>
            </el-input>
            </el-form-item>
        </el-form>
        <div class="">
            <el-button class="button-red button__base__admin" v-on:click="findBranch('search')">Search
            </el-button>
        </div>

        <div class="layout__padding-20-0">
            <p class="text__align-left">Search Results</p>
            <el-select filterable placeholder="Select a Branch"
                       clearable v-on:change="selectBranch">
                <el-option
                        v-for="result in results"
                        :key="result.name"
                        :value="result">
                    {{result.ref}} | {{result.customerName}} | {{result.branchName}} | {{result.address1}} - {{result.postcode}}
                </el-option>
            </el-select>
        </div>


        <!--{{results}}<br>-->
        <!--{{bespokeOrder}}-->
    </div>

</template>

<script>

    import {Loading} from 'element-ui';
    import Axios from 'axios';
    import {axios} from '@/mixins/Axios.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import {backing} from '@/mixins/Backing.js';

    export default {
        name: "addressSearchBespoke",
        mixins: [axios, dataFormatter, backing],
        props: {
            bespokeOrder: Object,
            searchType: String
        },
        data() {
            return {
                search: {
                    freetextSearch: ''
                },
                freetextQueryOptions: [],
                results: [],
                serviceRouteUrl: `${process.env.VUE_APP_ACCOUNTSAPIHOST}`,
                resourcePath: '/odata/customersearch?$filter=',
                finalQuery: '',
                queryConcatOr: '+or+',
                invoiceFilter: 'and+status+eq+\'ACTIVE\'&$select=ref,customername,address1,address2,address3,town,county,postcode,territory,customerName,branchName,invoiceAddress',
                rules: {
                    freetextSearch: [
                        {
                            required: true,
                            message: 'Value required for Search',
                            trigger: 'blur'
                        },
                    ],
                }
            }
        },
        created() {

        },
        beforeUpdate() {
        },

        methods: {
            selectBranch(row) {

                // todo add validation
                if (this.searchType === 'invoice') {
                    this.selectInvoiceBranch(row)
                } else if (this.searchType === 'delivery') {
                    this.selectDeliveryBranch(row)
                }
            },
            findBranch(search) {

                this.$refs[search].validate((valid) => {
                    if (valid) {

                        let loadingInstance = Loading.service({
                            // fullscreen: true,
                            background: 'white'
                        });

                        // let baseQueryUri = this.serviceRouteUrl + this.resourcePath
                        //
                        // this.freetextQueryOptions.push('contains(ref, \'' + this.search.freetextSearch + '\')')
                        // this.freetextQueryOptions.push('contains(brand, \'' + this.search.freetextSearch + '\')')
                        // this.freetextQueryOptions.push('contains(customername, \'' + this.search.freetextSearch + '\')')

                        // this.finalQuery = baseQueryUri.concat('(' + this.freetextQueryOptions.join(this.queryConcatOr) + ')', this.invoiceFilter)



                        this.finalQuery = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/Search/customerLookup?freetext=` + this.search.freetextSearch


                        // const finalQuery = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/odata/customersearch?$filter=ref+eq+\'` + this.freetextSearch + '\'+and+status+eq+\'ACTIVE\''
                        console.log(this.finalQuery)
                        // console.log('SEARCHING**********')
                        Axios.get(this.finalQuery, this.returnHeaderUsingToken())
                            .then(response => {
                                console.log(response)
                                this.results = []
                                this.results = response.data.value

                                this.$nextTick(() => { // Loading should be closed asynchronously
                                    loadingInstance.close();
                                });

                                // document.getElementById('showBranchSearchDialog').click()
                            })
                            .catch(error => {
                                this.$nextTick(() => { // Loading should be closed asynchronously
                                    loadingInstance.close();
                                    // document.getElementById('showBranchSearchDialog').click()
                                });
                            })
                    } else {
                        return false;
                    }
                })

                // document.getElementById('showBranchSearchDialog').click()
            },
            selectDeliveryBranch(row) {

                this.bespokeOrder.deliveryAddress1 = row.address1
                this.bespokeOrder.deliveryAddress2 = row.address2
                this.bespokeOrder.deliveryAddress3 = row.address3
                this.bespokeOrder.deliveryTown = row.town
                this.bespokeOrder.deliveryCounty = row.county
                this.bespokeOrder.deliveryPostcode = row.postcode
                this.bespokeOrder.deliveryName = row.branchName
                this.bespokeOrder.deliveryDepot = row.ref
                this.resetCloseDialog()
            },
            selectInvoiceBranch(row) {
                console.log(row)

                this.bespokeOrder.deliveryAddress1 = row.address1
                this.bespokeOrder.deliveryAddress2 = row.address2
                this.bespokeOrder.deliveryAddress3 = row.address3
                this.bespokeOrder.deliveryTown = row.town
                this.bespokeOrder.deliveryCounty = row.county
                this.bespokeOrder.deliveryPostcode = row.postcode
                this.bespokeOrder.salesperson = row.territory
                this.bespokeOrder.name = row.customerName
                this.bespokeOrder.deliveryName = row.branchName
                this.bespokeOrder.invoiceAddress = row.invoiceAddress
                this.bespokeOrder.branch = row.ref
                this.resetCloseDialog()
            },
            resetCloseDialog() {
                this.results = []
                this.search.freetextSearch = ''
                this.finalQuery = ''
                document.getElementById('showBranchSearchDialog').click()
            }

        }
    };
</script>